<template>
  <div class="custom-empty-wrapper">
    <van-empty :image="image" :image-size="imageSize" :description="description" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs, useAppStore } from '@star/stores';
import type { EmptyProps } from 'vant';
import { includes } from 'lodash-es';
import { ThemeEnum } from '@star/constants';

// type Props = {
//   message?: string;
// };

const props = withDefaults(defineProps<EmptyProps>(), {
  imageSize: 160,
  description: '暂无任何数据',
});

const { theme } = storeToRefs(useAppStore());

const image = computed(() => {
  return props.image || !includes([ThemeEnum.DARK], theme.value)
    ? '/images/empty.png'
    : `/images/empty-${theme.value}.png`;
});
</script>

<style lang="less" scoped>
.custom-empty-wrapper {
  padding-top: 60px;

  :deep(.van-empty) {
    &__image {
      height: auto !important;
    }
  }
}
</style>
